import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import CustomCondition from './customs/CustomCondition'
import FieldSentence from './FieldSentence'
import Icon from '../../../../../packages/kiti/components/shapes/Icon'
import OperatorSentence from './OperatorSentence'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import ValueSentence from './ValueSentence'

const ConditionItem = ({ condition, index, isLast, conditions }) => {
  const form = useForm()
  const { removeIn, addIn } = useFormState()

  return (
    <Grid gap={0.7} align="center">
      {!form?.readOnly && (
        <Col marginLeft={-4.7} width={4} marginTop={0.5}>
          <Grid gap={0.5} align="center">
            <Col flex={1} />
            {isLast && (
              <Icon name="BsPlusCircle" size={1.1} color="dark2" onClick={() => addIn(['conditions', index + 1], {})} />
            )}
            <Icon name="BsTrash" size={1.1} color="red" onClick={() => removeIn(['conditions', index])} />
          </Grid>
        </Col>
      )}
      <Text size="h2">{index === 0 ? 'se' : 'e'}</Text>
      <FieldSentence condition={condition} index={index} conditions={conditions} />

      <CustomCondition condition={condition} index={index} conditions={conditions}>
        <Text size="h2">for</Text>
        <OperatorSentence condition={condition} index={index} />
        <ValueSentence condition={condition} index={index} />
      </CustomCondition>
    </Grid>
  )
}

export default ConditionItem
